import { render, staticRenderFns } from "./AccountProtected.vue?vue&type=template&id=10aa888c"
import script from "./AccountProtected.vue?vue&type=script&lang=ts"
export * from "./AccountProtected.vue?vue&type=script&lang=ts"
import style0 from "./AccountProtected.vue?vue&type=style&index=0&id=10aa888c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports